'use client';

import { createContext, useContext } from 'react';

/**
 * The seam a surface uses to hand off to the global **Find** palette (the
 * `Ctrl+O` quick-open), docs/VIEWS.md §12's "escalation, not dead-end". A
 * local Refine that matches nothing in its view offers "Search everywhere →";
 * activating it opens the palette in Open mode, seeded with the current text.
 *
 * The shell (which owns the `QuickSwitcher` and its open state) publishes an
 * opener through this context; a descendant filter (the Work list filter, the
 * board Refine) consumes it. Null when no shell is above (the palette does not
 * exist there), so the escalation affordance simply does not render.
 */
export interface PaletteOpener {
  /** Open the global quick-open palette (Find) in Open mode, optionally seeded
   *  with `query` (the text the local Refine failed to match). */
  open: (query?: string) => void;
}

export const PaletteOpenContext = createContext<PaletteOpener | null>(null);

/** The palette opener published by the shell, or null when there is none. */
export function usePaletteOpener(): PaletteOpener | null {
  return useContext(PaletteOpenContext);
}
